export default __webpack_public_path__ + "static/media/bkg--location-2.a013d25c.jpg";